import React from 'react';

import { Treatment } from '../../../../types/treatment';
import FormsDisplayLayout from '../../FormsDisplayLayout/FormsDisplayLayout';
import { title, DISABLED_FIELDS } from '../CheckPaymentForm';

const CheckDisplay = ({ treatment }: { treatment: Treatment }) => {
  return <FormsDisplayLayout treatment={treatment} disabledFields={DISABLED_FIELDS} />;
};

export default CheckDisplay;

export const CheckDisplayOption = {
  title: title,
  Component: CheckDisplay,
};
